<template>
    <div>
        <section class="section section-gray">
            <div class="container">
                <div class="row">
                    <a class="target" aria-hidden="true" name="target" id="contacts">&nbsp;</a>
                    <h2 class="section-heading contacts-heading col-12">
                        Contacts
                    </h2>
                    <div v-for="item in offices" v-bind:key="item.name" :class="getClass(item.name)">
                        <h3 class="office-heading">{{ item.name }}</h3>
                        <div class="address-text">
                            <div class="row">
                                <div
                                    :class="item.name === 'Singapore' ? 'col-12 col-sm-6 col-xl-3 address-block' : 'col-12 address-block'">
                                    <p v-for="line in item.address" v-bind:key="line">{{ line }}</p>

                                    <a href="#" class="map-view-link"
                                        v-on:click="navigateOnMap(item.position, $event)">view on map</a>

                                    <div v-if="item.telephone" class="phone-link">
                                        <p v-for="phone in item.telephone" v-bind:key="phone">T: {{ phone }}</p>
                                    </div>

                                    <p v-if="item.fax">F: {{ item.fax }}</p>
                                </div>

                                <div v-if="item.name === 'Singapore'" class="col-12 col-sm-6 col-xl-9 row">
                                    <div class="mails-block col-12 col-xl-4">
                                        <h4>Chartering</h4>
                                        <a v-for="mail in item.mails.chartering" v-bind:key="mail"
                                            :href="getMailto(mail)">{{ mail }}</a>
                                    </div>
                                    <div class="mails-block col-12 col-xl-4">
                                        <h4>Operations</h4>
                                        <a v-for="mail in item.mails.operations" v-bind:key="mail"
                                            :href="getMailto(mail)">{{ mail }}</a>
                                    </div>
                                    <div class="mails-block col-12 col-xl-4">
                                        <h4>Accounting &amp; administration</h4>
                                        <a v-for="mail in item.mails.admin" v-bind:key="mail" :href="getMailto(mail)">{{
                        mail }}</a>
                                    </div>
                                </div>

                                <div v-if="item.mail" class="col-12">
                                    <a :href="getMailto(item.mail)">{{ item.mail }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <l-map ref="myMap" class="section map-container" id="map" aria-label="Office locations map" role="application"
            :zoom="mapZoom" :center="mapCenter">
            <l-tile-layer :url="mapTileUrl" :attribution="mapTileAttribution"></l-tile-layer>
            <l-marker v-for="marker in markers" v-bind:key="marker[0]" :lat-lng="marker" :icon="icon"></l-marker>
        </l-map>
    </div>
</template>

<script>
import * as L from "leaflet";
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';

export default {
    name: "Locations",
    components: {
        LMap,
        LTileLayer,
        LMarker
    },
    data() {
        return {
            map: null,
            mapZoom: 3,
            mapCenter: [33, 70],
            mapTileUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            mapTileAttribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            icon: L.divIcon({
                iconAnchor: [0, 16],
                labelAnchor: [-4, 0],
                popupAnchor: [0, -24],
                html: "<span class='mapIcon' />"
            })
        }
    },
    computed: {
        offices() {
            return this.$store.getters.orderedContacts;
        },
        markers() {
            let markers = [];

            for (let i = 0; i < this.offices.length; i++) {
                markers.push(this.offices[i].position.split(","));
            }

            return markers;
        }
    },
    methods: {
        getClass(name) {
            let length = this.offices.length;

            if (name === 'Singapore') {
                return 'office col-12';
            } else {
                if (length - 1 === 1) {
                    return 'office col-12';
                } else if (length - 1 === 2) {
                    return 'office col-12 col-sm-6';
                } else if (length - 1 === 3) {
                    return 'office col-12 col-lg-4';
                } else if (length - 1 === 4) {
                    return 'office col-12 col-sm-6 col-xl-3';
                } else if (length - 1 === 5) {
                    return 'office col-12 col-sm-6 col-lg-4';
                } else if (length - 1 === 4) {
                    return 'office col-12 col-sm-6 col-lg-4';
                }
            }

            return 'office col-12 col-sm-6 col-xl-3';
        },
        getMailto: (mail) => {
            return "mailto:" + mail
        },
        navigateOnMap: function (pos, ev) {
            ev.preventDefault();

            if (pos) {
                var location = pos.split(',');
                var zoom = 16;

                document.getElementById('map').scrollIntoView();
                this.map.setView(location, zoom, {
                    animate: true
                });

                return false;
            }
        },
    },
    mounted() {
        let viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        this.mapZoom = viewportWidth < 576 ? 2 : 3;
        this.map = this.$refs.myMap.mapObject
    }
}
</script>

<style scoped>
/* Contacts */
.contacts-heading {
    padding-bottom: 0.6em;
}

.office {
    padding-bottom: 2em;
}

.office-heading {
    font-weight: 400;
    margin-bottom: 0.5em;
}

.address-text p {
    margin: 0;
    padding: 0;
}

.address-text .map-view-link {
    display: block;
}

.address-text h4 {
    font-size: 1.2em;
}

.address-text .mails-block {
    margin-bottom: 1em;
}

.address-text .mails-block a {
    display: block;
}

.address-text .phone-link,
.address-text .map-view-link {
    padding-top: 1em;
}

.address-text .address-block {
    margin-bottom: 1em;
}

@media only screen and (min-width: 576px) {

    .address-text .map-view-link,
    .address-text .address-block {
        padding-top: 1em;
        display: block;
    }

    .office {
        padding-top: 2em;
        padding-bottom: inherit;
    }
}

/* Map */
.map-container {
    height: 400px;
    overflow: hidden;
    margin-bottom: 80px;
}

@media only screen and (min-width: 576px) {
    .map-container {
        height: 500px;
    }
}
</style>